import React from "react";
import AnonymousLayout from "components/Layout/AnonymousLayout";
import Login from "features/Login/LoginMaintenance";
import {Loader} from "components/FormComponents/Loader/Loader";
import {Navigate} from "react-router-dom";
import TrainingViewer from "features/Login/TrainingViewer/TrainingViewer";

const LazyForgotPassword = React.lazy(
  async () => await import("../features/Login/ForgotPassword/ForgotPassword"),
);
const LazyChangePassword = React.lazy(
  async () => await import("../features/Login/ChangePassword/ChangePassword"),
);
const LazyRequestAccount = React.lazy(
  async () => await import("../features/Login/RequestAccount/RequestAccount"),
);
const LazyPrivacyStatement = React.lazy(
  async () => await import("features/Login/PrivacyStatement"),
);
const LazyTermsOfUse = React.lazy(
  async () => await import("features/Login/TermsOfUse"),
);
const LazyUserProfile = React.lazy(
  async () => await import("../features/Login/UserProfile/UserProfile"),
);

const LazyThanks = React.lazy(
  async () => await import("features/Login/Thanks"),
);
const LazyFirstTimeLogin = React.lazy(
  async () => await import("../features/Login/FirstTimeLogin/FirstTimeLogin"),
);

const LazyPreviewRequestForm = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/PreviewRequestForm"
    ),
);

const LazyOrfForm = React.lazy(
  async () => await import("features/Activity/components/Forms/ORFForm"),
);
const LazyArfForm = React.lazy(
  async () => await import("features/Activity/components/Forms/ARFForm"),
);

const AnonymousRoutes = {
  element: <AnonymousLayout />,
  children: [
    {
      path: "*",
      element: <Navigate to="/" />,
    },
    {
      path: "/training/*",
      element: <TrainingViewer />,
    },
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/thanks",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyThanks />
        </React.Suspense>
      ),
    },
    {
      path: "/userprofile",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyUserProfile />
        </React.Suspense>
      ),
    },
    {
      path: "/forgotpwd",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyForgotPassword />
        </React.Suspense>
      ),
    },
    {
      path: "/changepwd",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyChangePassword />
        </React.Suspense>
      ),
    },
    {
      path: "/firstlogin",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyFirstTimeLogin />
        </React.Suspense>
      ),
    },
    {
      path: "/requestaccount",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyRequestAccount />
        </React.Suspense>
      ),
    },
    {
      path: "/privacy",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyPrivacyStatement />
        </React.Suspense>
      ),
    },
    {
      path: "/termsofuse",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyTermsOfUse />
        </React.Suspense>
      ),
    },
    {
      path: "/user/requestform",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyPreviewRequestForm />
        </React.Suspense>
      ),
    },
    {
      path: "/activity/orf",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyOrfForm />
        </React.Suspense>
      ),
    },
    {
      path: "/activity/arfform",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyArfForm />
        </React.Suspense>
      ),
    },
  ],
};

export default AnonymousRoutes;
